import { FC } from 'react';

import { Reveal } from '../ui/reveal';
import { RecentProjectCard } from './recent-project-card';
import { RecentProjectCardType } from './types/recent-project';

interface RecentProjectsProps {
  data: RecentProjectCardType[];
}

export const RecentProjects: FC<RecentProjectsProps> = ({ data }) => {
  return (
    <section id="projects" className="scroll-mt-28">
      <Reveal>
        <h1 className="heading">
          A small selection of
          {' '}
          <span className="text-purple">recent projects.</span>
        </h1>
      </Reveal>
      <div className="flex flex-wrap items-center justify-center p-4 gap-16 gap-y-24 mt-10">
        {data.map((project, index) => (
          <Reveal key={project.id} delay={Math.min(index, 3) * 0.08} amount={0.2}>
            <RecentProjectCard item={project} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};
